module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/881012fca0025054a61e160c94555c25.png";